// Sport-specific terminology and affirmations configuration
export const sportConfigs = {
  soccer: {
    terminology: {
      field: 'field',
      player: 'soccer star',
      champion: 'soccer champion',
      superstar: 'soccer superstar',
      wizard: 'soccer wizard',
      demon: 'soccer SPEED DEMON',
      action: 'dribble',
      bodyPart: 'feet',
      skill: 'FOOTWORK',
      goal: 'goal',
      location: 'soccer field',
    },
    affirmations: [
      'soccer star',
      'soccer champion',
      'soccer superstar',
      'soccer wizard',
      'soccer SPEED DEMON',
      'soccer FOOTWORK CHAMPION',
    ],
    emoji: '⚽',
  },
  basketball: {
    terminology: {
      field: 'court',
      player: 'basketball star',
      champion: 'basketball champion',
      superstar: 'basketball superstar',
      wizard: 'basketball wizard',
      demon: 'basketball SPEED DEMON',
      action: 'dribble',
      bodyPart: 'feet',
      skill: 'FOOTWORK',
      goal: 'basket',
      location: 'basketball court',
    },
    affirmations: [
      'basketball star',
      'basketball champion',
      'basketball superstar',
      'basketball wizard',
      'basketball SPEED DEMON',
      'basketball FOOTWORK CHAMPION',
    ],
    emoji: '🏀',
  },
  swimming: {
    terminology: {
      field: 'pool',
      player: 'swimming star',
      champion: 'swimming champion',
      superstar: 'swimming superstar',
      wizard: 'swimming wizard',
      demon: 'swimming SPEED DEMON',
      action: 'kick',
      bodyPart: 'legs',
      skill: 'KICK',
      goal: 'race',
      location: 'pool',
    },
    affirmations: [
      'swimming star',
      'swimming champion',
      'swimming superstar',
      'swimming wizard',
      'swimming SPEED DEMON',
      'swimming KICK CHAMPION',
    ],
    emoji: '🏊',
  },
  tennis: {
    terminology: {
      field: 'court',
      player: 'tennis star',
      champion: 'tennis champion',
      superstar: 'tennis superstar',
      wizard: 'tennis wizard',
      demon: 'tennis SPEED DEMON',
      action: 'serve',
      bodyPart: 'arms',
      skill: 'SERVE',
      goal: 'point',
      location: 'tennis court',
    },
    affirmations: [
      'tennis star',
      'tennis champion',
      'tennis superstar',
      'tennis wizard',
      'tennis SPEED DEMON',
      'tennis SERVE CHAMPION',
    ],
    emoji: '🎾',
  },
  volleyball: {
    terminology: {
      field: 'court',
      player: 'volleyball star',
      champion: 'volleyball champion',
      superstar: 'volleyball superstar',
      wizard: 'volleyball wizard',
      demon: 'volleyball SPEED DEMON',
      action: 'spike',
      bodyPart: 'arms',
      skill: 'SPIKE',
      goal: 'point',
      location: 'volleyball court',
    },
    affirmations: [
      'volleyball star',
      'volleyball champion',
      'volleyball superstar',
      'volleyball wizard',
      'volleyball SPEED DEMON',
      'volleyball SPIKE CHAMPION',
    ],
    emoji: '🏐',
  },
  football: {
    terminology: {
      field: 'field',
      player: 'football star',
      champion: 'football champion',
      superstar: 'football superstar',
      wizard: 'football wizard',
      demon: 'football SPEED DEMON',
      action: 'run',
      bodyPart: 'legs',
      skill: 'SPEED',
      goal: 'touchdown',
      location: 'football field',
    },
    affirmations: [
      'football star',
      'football champion',
      'football superstar',
      'football wizard',
      'football SPEED DEMON',
      'football SPEED CHAMPION',
    ],
    emoji: '🏈',
  },
  baseball: {
    terminology: {
      field: 'field',
      player: 'baseball star',
      champion: 'baseball champion',
      superstar: 'baseball superstar',
      wizard: 'baseball wizard',
      demon: 'baseball SPEED DEMON',
      action: 'hit',
      bodyPart: 'arms',
      skill: 'SWING',
      goal: 'home run',
      location: 'baseball field',
    },
    affirmations: [
      'baseball star',
      'baseball champion',
      'baseball superstar',
      'baseball wizard',
      'baseball SPEED DEMON',
      'baseball SWING CHAMPION',
    ],
    emoji: '⚾',
  },
  track: {
    terminology: {
      field: 'track',
      player: 'track star',
      champion: 'track champion',
      superstar: 'track superstar',
      wizard: 'track wizard',
      demon: 'track SPEED DEMON',
      action: 'run',
      bodyPart: 'legs',
      skill: 'SPEED',
      goal: 'finish line',
      location: 'track',
    },
    affirmations: [
      'track star',
      'track champion',
      'track superstar',
      'track wizard',
      'track SPEED DEMON',
      'track SPEED CHAMPION',
    ],
    emoji: '🏃',
  },
  gymnastics: {
    terminology: {
      field: 'gym',
      player: 'gymnastics star',
      champion: 'gymnastics champion',
      superstar: 'gymnastics superstar',
      wizard: 'gymnastics wizard',
      demon: 'gymnastics FLEXIBILITY DEMON',
      action: 'flip',
      bodyPart: 'body',
      skill: 'FLEXIBILITY',
      goal: 'perfect routine',
      location: 'gymnastics gym',
    },
    affirmations: [
      'gymnastics star',
      'gymnastics champion',
      'gymnastics superstar',
      'gymnastics wizard',
      'gymnastics FLEXIBILITY DEMON',
      'gymnastics FLEXIBILITY CHAMPION',
    ],
    emoji: '🤸',
  },
  martial_arts: {
    terminology: {
      field: 'dojo',
      player: 'martial arts star',
      champion: 'martial arts champion',
      superstar: 'martial arts superstar',
      wizard: 'martial arts wizard',
      demon: 'martial arts POWER DEMON',
      action: 'kick',
      bodyPart: 'legs',
      skill: 'POWER',
      goal: 'belt',
      location: 'dojo',
    },
    affirmations: [
      'martial arts star',
      'martial arts champion',
      'martial arts superstar',
      'martial arts wizard',
      'martial arts POWER DEMON',
      'martial arts POWER CHAMPION',
    ],
    emoji: '🥋',
  },
  dance: {
    terminology: {
      field: 'studio',
      player: 'dance star',
      champion: 'dance champion',
      superstar: 'dance superstar',
      wizard: 'dance wizard',
      demon: 'dance RHYTHM DEMON',
      action: 'dance',
      bodyPart: 'body',
      skill: 'RHYTHM',
      goal: 'performance',
      location: 'dance studio',
    },
    affirmations: [
      'dance star',
      'dance champion',
      'dance superstar',
      'dance wizard',
      'dance RHYTHM DEMON',
      'dance RHYTHM CHAMPION',
    ],
    emoji: '💃',
  },
  lacrosse: {
    terminology: {
      field: 'field',
      player: 'lacrosse star',
      champion: 'lacrosse champion',
      superstar: 'lacrosse superstar',
      wizard: 'lacrosse wizard',
      demon: 'lacrosse SPEED DEMON',
      action: 'shoot',
      bodyPart: 'arms',
      skill: 'SHOOT',
      goal: 'goal',
      location: 'lacrosse field',
    },
    affirmations: [
      'lacrosse star',
      'lacrosse champion',
      'lacrosse superstar',
      'lacrosse wizard',
      'lacrosse SPEED DEMON',
      'lacrosse SHOOT CHAMPION',
    ],
    emoji: '🥍',
  },
  rugby: {
    terminology: {
      field: 'field',
      player: 'rugby star',
      champion: 'rugby champion',
      superstar: 'rugby superstar',
      wizard: 'rugby wizard',
      demon: 'rugby POWER DEMON',
      action: 'tackle',
      bodyPart: 'body',
      skill: 'POWER',
      goal: 'try',
      location: 'rugby field',
    },
    affirmations: [
      'rugby star',
      'rugby champion',
      'rugby superstar',
      'rugby wizard',
      'rugby POWER DEMON',
      'rugby POWER CHAMPION',
    ],
    emoji: '🏉',
  },
  cricket: {
    terminology: {
      field: 'pitch',
      player: 'cricket star',
      champion: 'cricket champion',
      superstar: 'cricket superstar',
      wizard: 'cricket wizard',
      demon: 'cricket SPEED DEMON',
      action: 'bat',
      bodyPart: 'arms',
      skill: 'BAT',
      goal: 'run',
      location: 'cricket pitch',
    },
    affirmations: [
      'cricket star',
      'cricket champion',
      'cricket superstar',
      'cricket wizard',
      'cricket SPEED DEMON',
      'cricket BAT CHAMPION',
    ],
    emoji: '🏏',
  },
  golf: {
    terminology: {
      field: 'course',
      player: 'golf star',
      champion: 'golf champion',
      superstar: 'golf superstar',
      wizard: 'golf wizard',
      demon: 'golf PRECISION DEMON',
      action: 'swing',
      bodyPart: 'arms',
      skill: 'PRECISION',
      goal: 'hole',
      location: 'golf course',
    },
    affirmations: [
      'golf star',
      'golf champion',
      'golf superstar',
      'golf wizard',
      'golf PRECISION DEMON',
      'golf PRECISION CHAMPION',
    ],
    emoji: '⛳',
  },
  hockey: {
    terminology: {
      field: 'rink',
      player: 'hockey star',
      champion: 'hockey champion',
      superstar: 'hockey superstar',
      wizard: 'hockey wizard',
      demon: 'hockey SPEED DEMON',
      action: 'skate',
      bodyPart: 'legs',
      skill: 'SKATE',
      goal: 'goal',
      location: 'hockey rink',
    },
    affirmations: [
      'hockey star',
      'hockey champion',
      'hockey superstar',
      'hockey wizard',
      'hockey SPEED DEMON',
      'hockey SKATE CHAMPION',
    ],
    emoji: '🏒',
  },
};

// Helper function to generate sport-specific text
export const generateSportText = (baseText, sport) => {
  if (!sport || !sportConfigs[sport]) {
    return baseText;
  }

  const config = sportConfigs[sport];
  let result = baseText;

  // Replace common placeholders
  result = result.replace(/{sport}/g, sport);
  result = result.replace(/{sportStar}/g, config.terminology.player);
  result = result.replace(/{sportChampion}/g, config.terminology.champion);
  result = result.replace(/{sportSuperstar}/g, config.terminology.superstar);
  result = result.replace(/{sportWizard}/g, config.terminology.wizard);
  result = result.replace(/{sportDemon}/g, config.terminology.demon);
  result = result.replace(/{sportField}/g, config.terminology.field);
  result = result.replace(/{sportLocation}/g, config.terminology.location);
  result = result.replace(/{sportAction}/g, config.terminology.action);
  result = result.replace(/{sportBodyPart}/g, config.terminology.bodyPart);
  result = result.replace(/{sportSkill}/g, config.terminology.skill);
  result = result.replace(/{sportGoal}/g, config.terminology.goal);

  return result;
};

// Helper function to generate sport-specific timed instructions
export const generateSportInstructions = (baseInstructions, sport) => {
  if (!sport || !sportConfigs[sport]) {
    return baseInstructions;
  }

  return baseInstructions.map((instruction) => ({
    ...instruction,
    text: generateSportText(instruction.text, sport),
  }));
};

// Helper function to get random affirmation
export const getRandomAffirmation = (sport) => {
  if (!sport || !sportConfigs[sport]) {
    return 'star';
  }

  const affirmations = sportConfigs[sport].affirmations;
  return affirmations[Math.floor(Math.random() * affirmations.length)];
};
